import {Organisation} from '@/models/organisation'
import BaseService from '@/services/BaseService'
import {OrganisationJobTitle} from '@/models/organisationJobTitle'

export class OrganisationsService extends BaseService<Organisation> {
  constructor() {
    super('organisations/')
  }

  public async fetchNonValidatedOrganisations(): Promise<Organisation[]> {
    const result = await this.instance.get(this.resourcePath + '?validated=false')
    return result.data
  }

  public async fetchValidatedOrganisations(): Promise<Organisation[]> {
    const result = await this.instance.get(this.resourcePath + '?validated=true')
    return result.data
  }

  public async validateOrganisation(organisationID, licence) {
    const result = await this.instance.post(this.resourcePath + organisationID + '/validate/', {licence})
    return result
  }

  public async fetchJobTitles() {
    const result = await this.instance.get(this.resourcePath + 'fetch-job-titles/')
    return result.data
  }

  public async createJobTitle(jobTitle: string, for_guest: boolean) {
    const result = await this.instance.post(this.resourcePath + 'job-titles/', {title: jobTitle,for_guest: for_guest})
    return result
  }

  public async updateJobTitle(id: number, title: string, for_guest: boolean, is_validated: boolean = false) {
    const result = await this.instance.put(this.resourcePath + 'job-titles/', {id, title, for_guest, is_validated})
    return result
  }

  public async deleteJobTitle(id: number) {
    const result = await this.instance.delete(this.resourcePath + 'job-titles/', {data: {id}})
  }

  public async setUnsetSchoolAccess(id: number, schoolAccess: boolean){
    const result = await this.instance.post(this.resourcePath + id + '/organisation-set-school/', {'can_set_school': schoolAccess})
  }
}

export default new OrganisationsService()
